// eslint-disable-next-line @typescript-eslint/no-unused-vars
import styles from './app.module.scss';
import NxWelcome from './nx-welcome';
import { environment } from '../environments/environment';
import { useEffect } from 'react';

export function App() {
  useEffect(() => {
    document.title = environment.environ + " Hyperion"
  }, []);

  return (
    <>
      <NxWelcome title={environment.title} environ={environment.environ} />
      <div />
    </>
  );
}

export default App;
